<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      @if (isSingleRideCancellation()) {
        <span class="title-small-bold text-primary-color">Single Ride Cancellation</span>
      } @else {
        <span class="title-small-bold text-primary-color">Mass Ride Cancellations</span>
      }
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-xl flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    [formGroup]="form"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label label-large-medium text-primary-color"
        for="status">
        Status
      </label>
      <div class="form-group">
        <p-select
          appendTo="body"
          formControlName="status"
          [options]="statusOptions()"
          optionLabel="name"
          optionValue="id"
          placeholder="Select cancellation type" />
      </div>
    </div>

    @if (!isSingleRideCancellation()) {
      <div class="grid">
        <div class="col-6">
          <div class="form-group flex flex-column gap-spacing-xs">
            <label
              class="input-label label-large-medium text-primary-color"
              for="clientName">
              Client Name
            </label>
            <div class="form-group">
              <p-select
                [pTooltip]="form.get('client')?.value ? form.get('client')?.value.name : 'Client Name'"
                [autoHide]="false"
                [tooltipOptions]="tooltipOptions"
                appendTo="body"
                [filter]="true"
                [showClear]="true"
                formControlName="client"
                [options]="clients()"
                optionLabel="name"
                placeholder="Client Name" />
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="form-group flex flex-column gap-spacing-xs">
            <label
              class="input-label label-large-medium text-primary-color"
              for="placeName">
              Place Name
            </label>
            <div class="form-group">
              <p-select
                [pTooltip]="form.get('place')?.value ? form.get('place')?.value.name : 'Place Name'"
                [autoHide]="false"
                [tooltipOptions]="tooltipOptions"
                appendTo="body"
                [showClear]="true"
                [filter]="true"
                formControlName="place"
                [options]="places()"
                optionLabel="name"
                placeholder="Place Name" />
            </div>
          </div>
        </div>
        @if (form.get("client")?.touched && form.get("place")?.touched && !form.get("client")?.value && !form.get("place")?.value) {
          <small class="pl-spacing-lg input-helper-text label-medium-regular feedback-danger-fg-color">You must select at least a client or a place.</small>
        }
      </div>
    }

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex gap-spacing-default align-items-center label-large-medium text-primary-color"
        for="reasonInput"
        >Reason <span class="feedback-danger-fg-color">*</span></label
      >

      <div class="form-group">
        <p-select
          appendTo="body"
          [showClear]="true"
          [filter]="true"
          formControlName="reason"
          [options]="reasons()"
          optionLabel="name"
          placeholder="Select Reason" />
      </div>
    </div>

    @if (form.get("reason")?.value?.name === "Other") {
      <div class="form-group flex flex-column gap-spacing-xs">
        <label
          class="input-label flex gap-spacing-default align-items-center label-large-medium text-primary-color"
          for="otherReasonInput"
          >Other Reason <span class="feedback-danger-fg-color">*</span></label
        >

        <div class="form-group">
          <textarea
            rows="5"
            cols="30"
            id="otherReason"
            formControlName="otherReason"
            pTextarea
            [autoResize]="true"
            placeholder="Write your message here"
            class="w-full">
          </textarea>
        </div>
      </div>
    }
  </form>

  @if (!isSingleRideCancellation()) {
    <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
      <i class="icon-warning-solid text-xl icon-warning-color"></i>
      <ul class="mb-0 pl-spacing-2xl">
        <li class="label-large-regular text-warning-color">All the rides for the selected client(s) & place(s) will be canceled based on the ride time (Early or Late).</li>
      </ul>
    </div>
  }
</div>

<!-- Second dialog -->
<p-dialog
  [showHeader]="false"
  [modal]="true"
  [(visible)]="confirmationDialogVisible"
  [style]="{ width: '400px' }">
  <div class="p-dialog-header px-0">
    <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
      <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
    </span>
    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="closeConfirmDialog()"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs flex-column">
      <span class="title-small-bold text-primary-color">Attention!</span>
      @if (isSingleRideCancellation()) {
        <span class="text-caption-color label-large-medium"> Clicking on cancel ride will cancel the ride today. are you sure you want to proceed? </span>
      } @else if (rideCount) {
        <span class="text-caption-color label-large-medium"> Clicking on cancel ride will cancel {{ rideCount }} rides today. are you sure you want to proceed? </span>
      } @else {
        <span class="text-caption-color label-large-medium">There are no rides to be cancelled.</span>
      }
    </div>
  </div>

  <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
    <app-button
      label="Cancel"
      (btnClick)="closeConfirmDialog()"
      sizeClass="p-button-md"
      severity="secondary"></app-button>
    <app-button
      label="Proceed"
      [disabled]="loading || (!isSingleRideCancellation() && rideCount == 0)"
      (btnClick)="confirmAction()"
      sizeClass="p-button-md"
      severity="danger"></app-button>
  </div>
</p-dialog>
<!-- End Second dialog -->

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="isSubmitDisabled()"
    [label]="isSingleRideCancellation() ? 'Cancel Ride' : 'Cancel Rides'"
    (btnClick)="openConfirmDialog()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
